export default __webpack_public_path__ + "static/images/Run_all.png";